import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import Dashboard from '../CustomerCare/Dashboard';
import ComplaintsList from '../CustomerCare/ComplaintsList';
import NewComplaint from '../CustomerCare/NewComplaint';
import ComplaintDetail from '../CustomerCare/ComplaintDetail';

const CustomerCarePanel = () => {
    const [activeTab, setActiveTab] = useState('stats'); 
    const [selectedId, setSelectedId] = useState(null);
    const [stats, setStats] = useState(null);

    useEffect(() => {
        if(activeTab === 'stats') fetchStats();
    }, [activeTab]);

    const fetchStats = async () => {
        try {
            const res = await API.get('/customer-care/complaints/stats/dashboard');
            setStats(res.data.stats);
        } catch (err) { console.error(err); }
    };

    const navigateTo = (tab, id = null) => {
        setSelectedId(id);
        setActiveTab(tab);
    };

    return (
        <div style={styles.container}>
            
            <div style={styles.tabBar}>
                <div style={styles.navLinks}>
                    <button style={activeTab === 'stats' ? styles.activeTab : styles.tab} onClick={() => navigateTo('stats')}>📊 Dashboard</button>
                    <button style={(activeTab === 'complaints' || activeTab === 'detail') ? styles.activeTab : styles.tab} onClick={() => navigateTo('complaints')}>📋 All Complaints</button>
                    <button style={activeTab === 'new' ? styles.activeTab : styles.tab} onClick={() => navigateTo('new')}>➕ New</button>
                </div>
            </div>

            <div style={styles.content}>
                <div style={styles.scrollWrapper}>
                    
                    {activeTab === 'stats' && <Dashboard stats={stats} onNavigate={navigateTo} />}
                    
                    {activeTab === 'complaints' && (
                        <ComplaintsList 
                            onOpenDetail={(id) => navigateTo('detail', id)} 
                            onNavigate={navigateTo} 
                        />
                    )}
                    
                    {activeTab === 'new' && <NewComplaint onSaved={() => navigateTo('complaints')} onNavigate={navigateTo} />}

                    {activeTab === 'detail' && (
                        <ComplaintDetail 
                            id={selectedId} 
                            onBack={() => navigateTo('complaints')} 
                        />
                    )}

                </div>
            </div>
        </div>
    );
};

const styles = {
   container: { 
    height: '100vh', 
    display: 'flex', 
    flexDirection: 'column', 
    backgroundColor: '#f8fafc',
    overflow: 'hidden', // ⭐ Is se poora page hilna band ho jayega
},

    tabBar: { 
        flexShrink: 0,
        display: 'flex', 
        backgroundColor: '#fff', 
        padding: '12px 20px', 
        borderBottom: '1px solid #e2e8f0', 
        gap: '10px',
        alignItems: 'center',
        zIndex: 10,
    },

    navLinks: { 
        display: 'flex', 
        gap: '10px' 
    },

    tab: { 
        padding: '8px 16px', 
        border: 'none', 
        background: 'none', 
        cursor: 'pointer', 
        fontWeight: '600', 
        color: '#64748b', 
        fontSize: '14px',
    },

    activeTab: { 
        padding: '8px 16px', 
        border: 'none', 
        backgroundColor: '#4f46e5', 
        color: '#fff', 
        borderRadius: '8px', 
        cursor: 'pointer', 
        fontSize: '14px',
    },

  content: { 
    flex: 1,
    display: 'flex', 
    flexDirection: 'column',
    minHeight: 0, 
    backgroundColor: '#f1f5f9',
    overflow: 'hidden', // ⭐ Isko bhi hidden rakhein
}
};
export default CustomerCarePanel;